import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getMedia    = (params, token)   => Axios.get("/api/v1/admin/blog/media", { params, ...h(token) });
export const uploadMedia = (formData, token) => Axios.post("/api/v1/admin/blog/media", formData, h(token));
export const updateMedia = (id, data, token) => Axios.put(`/api/v1/admin/blog/media/${id}`, data, h(token));
export const deleteMedia = (id, token)       => Axios.delete(`/api/v1/admin/blog/media/${id}`, h(token));
